import axios from '@/utils/axios'
// 组件列表
export function list(query) {
    return axios({
        url: '/video/postback/getList',
        method: 'get',
        params: query
    })
}

// 付费回传列表
export function payList(query) {
    return axios({
        url: '/video/paypostback/getList',
        method: 'get',
        params: query
    })
}

// 组件详情
export function details(query) {
    return axios({
        url: '/video/postback/details',
        method: 'get',
        params: query
    })
}

// 付费列表详情
export function payDetails(query) {
    return axios({
        url: '/video/paypostback/details',
        method: 'get',
        params: query
    })
}

// 添加
export function add(query) {
    return axios({
        url: '/video/postback/addInfo',
        method: 'post',
        data: query
    })
}

// 付费添加
export function addPay(query) {
    return axios({
        url: '/video/paypostback/addInfo',
        method: 'post',
        data: query
    })
}

// 腾讯免费-添加
export function addTx(query) {
    return axios({
        url: '/video/VideoPostbackTxTx/addInfo',
        method: 'post',
        data: query
    })
}

// 腾讯免费-添加
// export function check(query) {
//     return axios({
//         url: '/video/VideoPostbackTxTx/addInfo',
//         method: 'post',
//         data: query
//     })
// }


